import { Routes } from '@angular/router';
import { MarketComponent } from './market.component';

export const MARKET_ROUTES: Routes = [
  {
    path: ':segmentoId',
    component: MarketComponent,
    data: {
      title: 'Market',
      icon: 'fa-solid fa-store',
      breadcrumb: 'Market'
    }
  }
];
